/**
 * Toast notification system for displaying temporary messages to users.
 * Requires toast containers in the DOM (typically in the header).
 */

// Track active messages to prevent duplicates
const activeMessages = new Set();

/**
 * Displays a temporary toast message to the user at the top of the viewport.
 * Messages automatically dismiss after 8 seconds with a smooth fade-out animation.
 * Duplicate messages are prevented from showing simultaneously.
 * 
 * @param {string} message - The message text to display
 * @param {string} type - Message type: 'success' or 'error' (determines styling)
 * @example
 * showToast('Item added to cart!', 'success');
 * showToast('Unable to process request', 'error');
 */
export function showToast(message, type) {
    const toastContainers = document.querySelectorAll('.toast-container');
    
    if (toastContainers.length === 0) {
        console.warn('Toast container not found, message not displayed:', message);
        return;
    }

    // Prevent duplicate messages
    const key = `${type}:${message}`;
    if (activeMessages.has(key)) return;
    
    activeMessages.add(key);

    const messageElements = [];
    
    // Add message to all toast containers (desktop + mobile)
    toastContainers.forEach(container => {
        const messageEl = document.createElement('div');
        messageEl.className = `toast-message toast-message--${type} toast-message--entering`;
        messageEl.textContent = message;
        container.appendChild(messageEl);
        messageElements.push(messageEl);
    });

    // Trigger slide-in animation by removing entering class
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            messageElements.forEach(el => el.classList.remove('toast-message--entering'));
        });
    });

    // Auto-dismiss after 8 seconds with fade-out
    setTimeout(() => {
        messageElements.forEach(el => el.classList.add('toast-message--fade-out'));
        setTimeout(() => {
            messageElements.forEach(el => el.remove());
            activeMessages.delete(key);
        }, 300);
    }, 8000);
}

if (typeof window !== 'undefined') {
    window.mannington = window.mannington || {};
    window.mannington.showToast = showToast;
}